import { coreUsersByIdPictureGetAsyncSlice } from './get';

export const { requestGetCoreUsersByIdPicture, resetGetCoreUsersByIdPicture } =
	coreUsersByIdPictureGetAsyncSlice.asyncActionCreators;
